import { CopyIcon } from "lucide-react";
import { ReactNode, useCallback } from "react";
import { Badge, BadgeProps } from "src/components/ui/badge";
import { useClipboard } from "src/hooks/useClipboard";
import { useTemporaryState } from "src/hooks/useTemporaryState";
import { cn } from "src/utilities/shadcnUtils";
import Tooltip from "./Tooltip";

export const ClipboardBadge = ({
  children,
  className,
  badgeClassName,
  hideIcon,
  ...props
}: Omit<BadgeProps, "children"> & {
  children: ReactNode;
  toCopy?: string;
  badgeClassName?: string;
  hideIcon?: boolean;
}) => {
  const onClick = useClipboard(props.toCopy || (typeof children === "string" ? children : ""));
  const [copy, setCopy] = useTemporaryState("Copy");

  const handleClick = useCallback(
    (evt: React.MouseEvent<HTMLButtonElement>) => {
      evt.stopPropagation();
      onClick?.(evt);
      setCopy("Copied", 3000, "Copy");
    },
    [onClick, setCopy]
  );

  return (
    <Tooltip className={cn("h-fit flex", className)} text={<p className="text-xs">{copy}</p>}>
      <button className="h-fit" onClick={handleClick}>
        <Badge className={cn("rounded-full h-fit", badgeClassName)} {...props}>
          {children}
          {hideIcon ? null : <CopyIcon className="w-3 h-3 ml-1 mb-[0.5px]" />}
        </Badge>
      </button>
    </Tooltip>
  );
};
